import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";

/**
 * Deletes a user from the Firestore database.
 *
 * @param userId - The ID of the user to delete.
 * @returns A promise that resolves when the deletion is complete.
 * @throws An error if the deletion fails.
 */
export async function deleteAuthor(userId: string): Promise<void> {
  if (!userId) {
    throw new Error("User ID must be provided.");
  }

  const userRef = firestore.collection(DB_PATH.AUTHOR).doc(userId);

  try {
    await userRef.delete();
    console.log(`User with ID ${userId} has been successfully deleted.`);
  } catch (error) {
    console.error(`Failed to delete user with ID ${userId}:`, error);
    throw error;
  }
}
